import {makeStyles} from '@material-ui/core/styles'
import {Text} from '../../../1elements'
import { formatDate } from '../../../../services/util/formatter'

const ViewItem = ({item}) => {
    const classes = useStyles()
    const {fieldData, label, type} = item

    switch (type) {
      case "Link":
        return (
          <Text type={'h9'} className={classes.label}><a href={fieldData} className={classes.link}>{label}</a></Text>
        )
      case "Date":
        return (<div className={classes.itemRow}><Text type={'h9'} className={classes.label}>{label} : <span>&nbsp;</span></Text><Text
          className={classes.textWrap}>{formatDate(fieldData)}</Text></div>)
      default:
        return (<div className={classes.itemRow}><Text type={'h9'} className={classes.label}>{label} : <span>&nbsp;</span></Text><Text
          className={classes.textWrap}>{fieldData}</Text></div>)
    }
}

export default ViewItem

const useStyles = makeStyles((theme)=>({
    label: {
        whiteSpace: 'nowrap'
    },
    textWrap: {
        overflowWrap: 'anywhere'
    },
    link: {
        color: theme.palette.primary.main,
        transition: 'color .25s',
        '&:hover': {
            color: theme.palette.primary.accent,
            textDecoration: 'underline'
        }
    },
    itemRow: {
        display: 'flex',
        alignItems: 'center',
        margin: '5px 0',
        maxWidth: '100%',
        width: '100%',
    },
}))